import {useState,useEffect} from "react";
import Main from './Branches/Main';

const App=()=>{

  const [dim,setDim]=useState({
    width:window.innerWidth,
    height:window.innerHeight
  });

  useEffect(() => {
    const handleResize=()=>setDim({
      width:window.innerWidth,
      height:window.innerHeight
    });
    window.addEventListener("resize", handleResize);
    return ()=>window.removeEventListener("resize", handleResize);
  }, []);

  return(
    <div style={{width:dim.width,height:dim.height}}>
      <Main/>
    </div>
  );
}

export default App;
